export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    CommentBase: ['Comment', 'TopicComment'],
    PossibleProject: ['Project', 'ProjectOfRound', 'ProjectOfVariation'],
    PossibleVariation: ['Variation', 'VariationOfRound'],
    ProjectBase: ['Project', 'ProjectOfRound', 'ProjectOfVariation'],
    RoundBase: ['Round', 'RoundOfProject'],
    VariationBase: ['RunningVariation', 'Variation', 'VariationOfRound'],
  },
};
export default result;
